import React, { useCallback } from 'react'
import { useNavigate, NavigateFunction } from 'react-router-dom'

import { t } from '@/i18n'
import { IBreadcrumb, ICar } from '@/types'
import { AppLayout, Breadcrumbs, LanguageSelector } from '@/components'
import { homePath, makeSearchPath, carsPath } from '@/utils/index'
import { useData } from './useData'
import Form from './form'

const breadcrumbs: IBreadcrumb[] = [
  {
    name: 'search',
    path: homePath,
  },
  {
    name: 'add_car',
  },
]

const AddCar: React.FC = () => {
  const navigate: NavigateFunction = useNavigate()
  const { data, loading, submitting, onCancel, onSubmit } = useData({})

  const onSubmitForm = useCallback(
    (d: ICar) => {
      onSubmit('cars/', false, res => {
        const viewPath = makeSearchPath(carsPath, {
          id: res.id,
          customerId: 'customer',
        })
        navigate(viewPath)
      })(d)
    },
    [navigate, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className="page-container">
        <div className="container">
          <div className="page-content">
            <div className="content-box">
              <div className="scroll-wrap">
                <div className="content-title">
                  <h2>{t('add_car')}</h2>
                </div>
                <Form
                  isEditing
                  loading={loading}
                  submitting={submitting}
                  initialData={data}
                  onCancel={onCancel}
                  onSubmit={onSubmitForm}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default AddCar
